import type { GuestBrowserCapability } from '../guestBrowserCapability';
import type { ReceiverCounterSummary } from '../streamQuality/streamQualityContracts';

export function freezeSignalAvailable(
  capability: GuestBrowserCapability | undefined,
  observedFreezeCount: number | undefined,
): boolean {
  return capability?.exposesFreezeCount ?? (observedFreezeCount !== undefined && observedFreezeCount >= 0);
}

export class GuestSignalProjector {
  constructor(private readonly exposesFreezeCount: boolean | undefined) {}

  projectReceiverCounters(summary: ReceiverCounterSummary | undefined): ReceiverCounterSummary | undefined {
    if (!summary || this.exposesFreezeCount !== false) return summary;
    const { freezes: _freezes, freezeMs: _freezeMs, ...supported } = summary;
    return Object.keys(supported).length > 0 ? supported : undefined;
  }

  projectFreezeDelta(summary: ReceiverCounterSummary | undefined): number | undefined {
    if (this.exposesFreezeCount === false) return undefined;
    return summary?.freezes;
  }
}
